<template>
	<modal v-if="isShowModal">
		<template slot="header">
			<h5>{{ $t('Import Lower Third Data') }}</h5>
		</template>
		<template slot="body">
			<div class="modal-import-box">
				<div>
					<div>
						<div>
							<loading :active.sync="importingUser" :is-full-page="fullPage"
								:background-color="colorOverlay" :color="colorLoading">
								<template slot="after">
									<div class="absolute text-center">{{ $t('loading') }}...</div>
								</template>
							</loading>
							<div class="vue-xlsx-container mr-1" @drop.prevent="addFileXlsx"
								@dragover.prevent>
									<span>
										<label v-if="!checkIsImport" class="ml-4" ><span @click="handleUploadBtnClick"><u>Select</u></span>
										or drag the file here to start import please make sure the format are correct
										</label>
									</span>
								<!-- <button type="button" class="btn btn-primary pr-0 pl-0"
									@click="handleUploadBtnClick">
									<slot>

									</slot>
								</button> -->
								<input :id="uploadInputId" type="file" :accept="accept"
									class="c-hide" @change="handleFileChange">
							</div>
							<span v-if="checkIsImport">
								<mdChip class="pr-1 pl-1 pt-0" color="green" text-color="white">
									{{ rawFile.name }}
								</mdChip>
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-2">
				<label class="text-grey medium">
					{{ $t('Select Lower Third Template') }}
				</label>
				<select :class="{ 'error-input': isRequired }" class="form-control"
					:placeholder="$t('Select Template')" @change="onSelect"
					v-model="templateId">
					<option v-for="template in templateItems"
						:key="template.id" :value="template.id">
						{{ template.name }}
					</option>
					<option value="0" disabled
						v-if="templateItems.length === 0">
						{{ $t('No Templates Available') }}
					</option>
				</select>
			</div>

			<div class="mt-4">
				<a href="./../../template-xlsx/TEMPLATE_LOWER_THIRD_DATA.xlsx"
					download>{{ $t('Download') }} Excel Template - {{ $t('Lower Third Data') }}</a>
			</div>
		</template>
		<template slot="footer">
			<div class="w-100 flex-center">
				<button @click="acceptImport" :disabled="!tmpUsers" type="submit"
					class="btn btn-submit btn-primary" :class="{ 'is-loading': isImporting }">
					<span>{{ $t('Upload') }}</span>
				</button>
				<button @click="close()" type="submit"
					:disabled="isImporting"
					class="btn btn-submit btn-default">
					<span>{{ $t('Cancel') }}</span>
				</button>
			</div>
		</template>
	</modal>
</template>

<script>
import XLSX from 'xlsx';
import Loading from 'vue-loading-overlay';
import Modal from '@/components/Modal.vue';
import rundownItemsApi from '@/api/rundownItems';
import {
	ColorDummyData,
} from '@/lib/statics';
import { duplicateVar, randomString } from '@/lib/helper';

export default {
	components: {
		Loading,
		Modal,
	},
	name: 'ImportLowerThirdData',
	data() {
		return {
			rawFile: null,
			workbook: null,
			tableData: {
				header: [],
				body: [],
			},
			ColorDummyData: duplicateVar(ColorDummyData),
			uploadInputId: (new Date().getUTCMilliseconds()),
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			importingUser: false,
			isImporting: false,
			tmpUsers: null,
			isRequired: false,
			templateId: '',
			isShowFileXlsx: false,
		};
	},
	props: {
		accept: {
			type: String,
			default: '.xlsx, .xls',
		},
		isShowModal: {
			type: Boolean,
		},

		rundown: {
			type: Object,
		},
		templateItems: {
			type: Array,
		},
	},
	computed: {
		checkIsImport() {
			if (!this.isShowFileXlsx) {
				return false;
			}
			return this.rawFile && this.isShowFileXlsx;
		},
		rABS() {
			return window.xlsxEventBus.XLSX_EVENTS_DATA.options.rABS;
		},
	},
	created() {
		this.isShowFileXlsx = false;
		this.rawFile = null;
	},
	methods: {
		close() {
			this.$emit('close');
		},
		onSelect() {

		},
		acceptImport() {
			this.createBulk(this.tmpUsers);
		},
		refetchItems(items) {
			this.$emit('fetchItems', items);
		},
		secondToString(value) {
			if (!value) return '00:05';
			const secNum = parseInt(value); // don't forget the second param
			const hours = Math.floor(secNum / 3600);
			let minutes = Math.floor((secNum - (hours * 3600)) / 60);
			let seconds = secNum - (hours * 3600) - (minutes * 60);
			if (minutes < 10) { minutes = `0${minutes}`; }
			if (seconds < 10) { seconds = `0${seconds}`; }
			return `${minutes}:${seconds}`;
		},
		async createBulk(items) {
			this.isImporting = true;
			const rundownId = this.rundown.id;
			const callback = (response) => {
				// this.insertItems(importedItems);
				const items = response.data;
				this.isImporting = false;
				this.refetchItems(items);
				this.close();
				const message = this.$t('Import Success');
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Import Lower Third Data',
					text: message,
				});
			};
			const errorCallback = () => {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Import Lower Third Data',
					text: 'error in importing data',
				});
				this.isImporting = false;
			};
			const tmpImportItems = [];
			const template = this.templateItems.find(item => item.id === this.templateId);
			const activeTemplate = template && template.file_path ? template.file_path : null;
			let y = 0;
			let width = 0;
			let height = 0;
			if (activeTemplate) {
				const data = await (await fetch(activeTemplate)).json();
				if (data.w && data.h) {
					width 	= data.w;
					height	= data.h;
					y = (height - 1080) * -1; // (lottie.height - canvas.height ) *- 1;
				}
			}

			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				const content = {
					width,
					height,
					duration: this.secondToString(item.DURATION),
					timer: this.secondToString(item.DURATION),
					position: 'default',
					x: 0,
					y,
					isRatio: true,
					fontStyle: 0,
					opacity: 1,
				};
				content.template = this.templateItems.find(item => item.id === this.templateId);
				// const data = await (await fetch(url)).json();
				// content.duration = '00:05';
				content.h1 = item.H1 || item.h1 || ' ';
				content.h2 = item.H2 || item.h2 || ' ';
				content.h3 = item.H3 || item.h3 || ' ';
				content.h4 = item.H4 || item.h4 || ' ';
				content.h1_color = this.ColorDummyData.colorText1;
				content.h2_color = this.ColorDummyData.colorText2;
				content.h3_color = this.ColorDummyData.colorText3;
				content.h4_color = this.ColorDummyData.colorText4;
				content.color_1 = this.ColorDummyData.fillColor1;
				content.color_2 = this.ColorDummyData.fillColor2;
				content.color_3 = this.ColorDummyData.fillColor3;
				content.color_4 = this.ColorDummyData.fillColor4;

				const params = {
					layer_index: item.LAYER_INDEX,
					name: `${index} ${item.H1} Third-${randomString(6)}`,
					type: 'lower_third',
					status: 1,
					content: JSON.stringify(content),
					is_play_live: 0,
					is_play_preview: 0,
					rundown_id: this.rundown.id,
				};
				tmpImportItems.push(params);
			}
			rundownItemsApi.createBulk(rundownId, tmpImportItems, callback, errorCallback);
		},

		// eslint no-empty: "error"
		addFileXlsx(e) {
			const droppedFiles = e.dataTransfer.files;
			this.rawFile = droppedFiles[0];
			this.fileConvertToWorkbook(this.rawFile)
				.then((workbook) => {
					const xlsxArr = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
					this.workbook = workbook;
					this.initTable(
						this.xlsxArrToTableArr(xlsxArr),
					);
				})
				// eslint-disable-next-line no-unused-vars
				.catch((err) => {
					// empty
				});
		},
		async handleFileChange(e) {
			if (this.rawFile !== null) {
				return;
			}
			this.rawFile = e.target.files[0];
			try {
				this.importingUser = true;
				const workbook = await this.fileConvertToWorkbook(this.rawFile);
				const xlsxArr = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
				this.workbook = workbook;
				this.initTable(
					this.xlsxArrToTableArr(xlsxArr),
				);
				this.importingUser = false;
				this.isShowFileXlsx = true;
			} catch (err) {
				this.importingUser = false;
				this.$notify({
					group: 'app',
					type: 'warning',
					title: 'Upload Media',
					text: 'Unsupported file',
				});
				// eslint-disable-next-line
				return;
			}
		},
		fileConvertToWorkbook(file) {
			const reader = new FileReader();
			const fixdata = (data) => {
				let o = '';
				let l = 0;
				const w = 10240;
				for (; l < data.byteLength / w; ++l) {
					o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
				}
				o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
				return o;
			};
			return new Promise((resolve, reject) => {
				try {
					reader.onload = (renderEvent) => {
						const data = renderEvent.target.result;
						if (this.rABS) {
							/* if binary string, read with type 'binary' */
							resolve(XLSX.read(data, {
								type: 'binary',
							}));
						} else {
							/* if array buffer, convert to base64 */
							const arr = fixdata(data);
							resolve(XLSX.read(btoa(arr), {
								type: 'base64',
							}));
						}
					};
					reader.onerror = (error) => {
						reject(error);
					};
					if (this.rABS) {
						reader.readAsBinaryString(file);
					} else {
						reader.readAsArrayBuffer(file);
					}
				} catch (error) {
					reject(error);
				}
			});
		},
		// custom - maulana yusup abdullah
		checkIfHeaderExist(headers, header) {
			let isExist = false;
			for (let i = 0; i < headers.length; i++) {
				const curr = headers[i];
				if (curr === header) {
					isExist = true;
				}
			}
			return isExist;
		},
		// custom - maulana yusup abdullah
		pushToHeaders(headers, rowHeaders) {
			let newHeaders = headers;
			if (newHeaders.length === 0) {
				newHeaders = rowHeaders;
				return newHeaders;
			}
			for (let i = 0; i < rowHeaders.length; i++) {
				const rowHead = rowHeaders[i];
				for (let j = 0; j < newHeaders.length; j++) {
					// eslint-disable-next-line no-unused-vars
					const currHead = newHeaders[j];
					const isExist = this.checkIfHeaderExist(newHeaders, rowHead);
					if (!isExist) {
						newHeaders.push(rowHead);
						break;
					}
				}
			}
			return newHeaders;
		},
		xlsxArrToTableArr(xlsxArr) {
			const tableArr = [];
			let length = 0;
			let maxLength = 0;
			// eslint-disable-next-line no-unused-vars
			let maxLengthIndex = 0;

			// custom - maulana yusup abdullah
			let headers = [];
			// eslint-disable-next-line no-unused-vars
			xlsxArr.forEach((item, index) => {
				const rowHeaders = Object.keys(item);
				headers = this.pushToHeaders(headers, rowHeaders);
			});

			// custom - maulana yusup abdullah
			xlsxArr.forEach((item, index) => {
				// length = Object.keys(item).length
				length = headers.length;
				if (maxLength < length) {
					maxLength = length;
					maxLengthIndex = index;
				}
			});

			// custom - maulana yusup abdullah
			// let tableHeader = Object.keys(xlsxArr[maxLengthIndex])
			const tableHeader = headers;
			let rowItem = {};
			xlsxArr.forEach((item) => {
				rowItem = {};
				for (let i = 0; i < maxLength; i++) {
					rowItem[tableHeader[i]] = item[tableHeader[i]] || '';
				}
				tableArr.push(rowItem);
			});
			return {
				header: tableHeader,
				data: tableArr,
			};
		},
		tableArrToXlsxArr({ data, header }) {
			const xlsxArr = [];
			let tempObj = {};
			data.forEach((rowItem) => {
				tempObj = {};
				rowItem.forEach((item, index) => {
					tempObj[header[index]] = item;
				});
				xlsxArr.push(tempObj);
			});
			return xlsxArr;
		},
		initTable({ data, header }) {
			this.tableData.header = header;
			this.tableData.body = data;
			const isHeaderValid = header
				&& ((header[0] === 'H1' || header[0] === 'h1')
				|| (header[1] === 'H2' || header[1] === 'h2')
				|| (header[2] === 'H3' || header[2] === 'h3')
				|| (header[3] === 'H4' || header[3] === 'h4'));
			if (isHeaderValid) {
				this.tmpUsers = data;
			} else {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Wrong File or Format',
					text: 'something went wrong on File or Format!',
				});
			}
		},
		handleUploadBtnClick() {
			this.clearAllData();
			document.getElementById(this.uploadInputId).click();
		},
		clearAllData() {
			document.getElementById(this.uploadInputId).value = null;
			this.tableData = {
				header: [],
				body: [],
			};
			this.rawFile = null;
			this.workbook = null;
		},
	},
};
</script>

<style lang="scss">
.vue-xlsx-container {
	display: inline-block;
	margin: 0;
	padding: 0;
	box-sizing: border-box;

	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.c-hide {
		display: none;
	}
}

.xlsx-button {
	display: inline-block;
	line-height: 1;
	white-space: nowrap;
	cursor: pointer;
	border: 1px solid #20a0ff;
	-webkit-appearance: none;
	text-align: center;
	box-sizing: border-box;
	outline: 0;
	margin: 0;
	padding: 7px 9px;
	font-size: 12px;
	border-radius: 4px;
	color: #fff;
	background-color: #20a0ff;

	&.button-large {
		padding: 10px 15px;
		font-size: 14px;
	}

	&.button-primary {
		color: #1f2d3d;
		border: 1px solid #bfcbd9;
		background-color: #fff;
	}
}
</style>
